module.exports = __webpack_public_path__ + "static/animationSlideImage2-d2306897c7f005d78671a1969aa0eb0c.png";